import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frontend-buffer',
  templateUrl: './frontend-buffer.component.html',
  styleUrls: ['./frontend-buffer.component.scss']
})
export class FrontendBufferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
